import { FC } from 'react';
import { Box, Typography, makeStyles } from '@material-ui/core';
import { LaunchTestButton } from './LaunchTestButton';
import Icon from './TestHistoryEmptyState.svg';

const useStyles = makeStyles(() => ({
  container: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '20px',
    marginTop: '36px',
  },
}));

export const TestHistoryEmptyState: FC = () => {
  const classes = useStyles();
  return (
    <Box className={classes.container}>
      <Typography style={{ fontWeight: 700 }} variant="h6">
        Your test history is currently empty.
      </Typography>
      <img src={Icon} alt="" />
      <Typography>Let's fill it up, by adding some tests!</Typography>
      <LaunchTestButton size="large" label="Run your first Test" />
    </Box>
  );
};
